/**
 * This component is used to prompt a subscription order user to either sign in or sign up.
 */
import React from 'react';
import withStyles from '@mui/styles/withStyles';
import { Button, Grid, Paper, Typography } from '@mui/material';
import AppBindStyles from '../../AppBindStyles';

import StepperSubscriptionOrder from './StepperSubscriptionOrder';


const styles = theme => ({
  root: {
    margin: "0 auto",
    padding: "0 72px"
  }, 
  signupPaper: {
    borderTopRightRadius: "10px",
    borderTopLeftRadius: "10px",
    borderBottomRightRadius: "10px",
    borderBottomLeftRadius: "10px",
    maxWidth: 600,
    width: '100%',
    minHeight: 200

  },
  title: {
    paddingTop: 8,
    paddingBottom: 8,
    backgroundColor: theme.palette.secondary.main,
    borderTopRightRadius: "10px",
    borderTopLeftRadius: "10px"
  },
  titleLine: {
    color : "white", 
    fontSize: "21px",
    fontWeight: "500",
    paddingLeft: "16px",
    paddingTop: "24px",
    paddingBottom: "8px"
  },
  stepper: {
    borderBottomRightRadius: "10px",
    borderBottomLeftRadius: "10px",
  },
  logo: {
    marginLeft: '8px', 
    marginBottom: '-6px'
  }
});


class StepSignInUp extends React.Component {
  

  constructor(props) {
    super(props);

    this.state = {
      

    };
  }

  login() {
    this.props.auth.login();
  }

  signup(email, companyName, firstName, lastName, accountPath) {
    let callTarget = 'appbind/vendor/' + accountPath;
    const { callPartnerApi } = this.props.auth;
    callPartnerApi(callTarget, 'GET', null)
    .then(response => {
      return response.json();
    }).then(data => {
      
      //There is not real branding so holding off on this
      //localStorage.setItem("vendorLogo", data.logo);
    
      this.props.auth.signupFromSO(email, companyName, firstName, lastName, data.accountId, data.logo);
    }).catch(err => {
      //TODO what should we do here?
    });
  }
  
  render() {
    const classes = this.props.classes;

    let jsonstring = localStorage.getItem('subscriptionOrder');
    var json = JSON.parse(jsonstring);

    var reseller = json.reseller;

    let accountPath = localStorage.getItem("accountPath");

    return (

      <div className={classes.root}>

        <Grid container spacing={3} direction="row" justifyContent="center">

          <Grid item  sm={12} md={5} style={{width: "100%", marginLeft:16, marginRight:16, marginTop: 24}}>
              <Grid container justifyContent="center" spacing={2}>
                <Paper className={classes.signupPaper}>

                  <Grid item  xs={12}>
                    <div className={classes.title}>
                      <Typography variant="h4" className={classes.titleLine} >
                        Log in to continue
                      </Typography>
                    </div>
                  </Grid>


                  <Grid item xs={12}>
                    <Grid container direction="row" alignItems="center" spacing={2} style={{marginTop: 16, marginBottom: 16, marginLeft: 16}}>
                      <Grid item xs={12}>
                        <div style={{display:"flex"}}>
                          <Typography  variant="body1"><b style={AppBindStyles.boldLabel}>First time?</b> Sign up to the order system.</Typography>
                        </div>
                      </Grid>
                      <Grid item>
                        <Button color="primary" variant="contained" onClick={this.signup.bind(this, reseller.contactEmail, reseller.companyName, reseller.contactFirstName, reseller.contactLastName, accountPath)}>Sign up</Button>
                      </Grid>
                      <Grid item>
                        <Typography variant="body1" color="primary">or</Typography>
                      </Grid>
                      <Grid item>
                        <Button color="primary" variant="outlined" onClick={this.login.bind(this)}>Log in</Button>
                      </Grid>
                    </Grid>
                  </Grid>

                  
                </Paper>
              </Grid>
          </Grid>

          <Grid item  sm={12} md={5} style={{width: "100%", marginLeft:16, marginRight:16, marginTop: 24}}>
            <StepperSubscriptionOrder auth={this.props.auth} json={json} />
          </Grid>

        </Grid>

      </div>
    );

  }
}

export default withStyles(styles)(StepSignInUp);